import React from 'react';
import PropTypes from 'prop-types';
import './MobileNavBarCategory.css';

export class MobileNavBarCategory extends React.Component {
  handleClick = () => {
    const { category, selectedCategory, selectedSubCategory, isActive } = this.props;

    if (isActive) {
      return this.props.onClick(selectedCategory, selectedSubCategory, undefined);
    }

    return this.props.onClick(selectedCategory, selectedSubCategory, category);
  };

  render() {
    const { isActive = false, selectedCategory, category } = this.props;

    const { image = '', name = '' } = this.props.category;

    const isSelected = name === selectedCategory.name;
    let imgSrc;
    try {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      imgSrc = require(`./assets/${image}.png`);
    } catch (e) {
      imgSrc = '';
    }

    let navBarCategoryClasses = 'nav-bar-category';
    navBarCategoryClasses += isSelected ? ' nav-bar-category--selected' : '';
    navBarCategoryClasses += isActive ? ' nav-bar-category--active' : '';

    return (
      <li className={navBarCategoryClasses}>
        <div id={category.id} className="nav-bar-category__link" onClick={this.handleClick}>
          <img className="nav-bar-category__icon" src={imgSrc} alt="" />
        </div>
      </li>
    );
  }
}

MobileNavBarCategory.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    sub_categories: PropTypes.arrayOf(
      PropTypes.shape({
        api_location: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    url: PropTypes.string,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  selectedCategory: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    sub_categories: PropTypes.arrayOf(
      PropTypes.shape({
        api_location: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    url: PropTypes.string,
  }).isRequired,
  selectedSubCategory: PropTypes.shape({
    api_location: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

MobileNavBarCategory.defaultProps = { onClick: undefined };
